import AWSCognitoManager from "./AWSCognitoManager";
import AWSDynamoDBManager from "./AWSDynamoDBManager";
import AWSLambdaManager from "./AWSLambdaManager";
import AWSS3Manager from "./AWSS3Manager";
export default class AWSManagerSingleton {
  //This class must be a Singleton to configure the class once
  constructor() {
    // Check if an instance already exists
    if (AWSManagerSingleton.instance) {
      return AWSManagerSingleton.instance;
    }

    this.region = "";
    this.UserPoolId = "";
    this.ClientId = "";

    this.AWSCognitoManager = null;

    // Save the instance for future reference
    AWSManagerSingleton.instance = this;
    // Return the instance
    return this;
  }

  static getInstance() {
    if (!AWSManagerSingleton.instance) {
      AWSManagerSingleton.instance = new AWSManagerSingleton();
    }
    return AWSManagerSingleton.instance;
  }

  //COGNITO Methods
  UseCognito(region = "eu-west-1", UserPoolId, ClientId, IdentityPoolId) {
    this.region = region;
    this.UserPoolId = UserPoolId;
    this.ClientId = ClientId;
    this.IdentityPoolId = IdentityPoolId;

    this.AWSCognitoManager = new AWSCognitoManager(
      region,
      UserPoolId,
      ClientId,
      IdentityPoolId
    );
  }

  async CognitoAuthenticateUser(username, password) {
    if (this.AWSCognitoManager == null) throw "AWSCognitoManager not set";
    return await this.AWSCognitoManager.AuthenticateUser(username, password);
  }

  async CognitoGetLoggedUserAttributes(){
     if (this.AWSCognitoManager == null) throw "AWSCognitoManager not set";
    return await this.AWSCognitoManager.GetUserAttributes();
  }

  async CognitoForgotPassword(username) {
    if (this.AWSCognitoManager == null) throw "AWSCognitoManager not set";
    return await this.AWSCognitoManager.ForgotPassword(username);
  }

  async CognitoResetPassword(username, password, confirmationCode) {
    if (this.AWSCognitoManager == null) throw "AWSCognitoManager not set";
    return await this.AWSCognitoManager.ResetPassword(
      username,
      password,
      confirmationCode
    );
  }
  async CognitoSetUserPassword(UserPoolId, username, password, setAsPermanent) {
    if (this.AWSCognitoManager == null) throw "AWSCognitoManager not set";
    return await this.AWSCognitoManager.SetUserPassword(
      UserPoolId,
      username,
      password,
      setAsPermanent
    );
  }

  async CognitoRefreshCredentials() {
    if (this.AWSCognitoManager == null) throw "AWSCognitoManager not set";
    return await this.AWSCognitoManager.RefreshCredentials();
  }

  async CognitoListGroups(userPoolID) {
    if (this.AWSCognitoManager == null) throw "AWSCognitoManager not set";
    return await this.AWSCognitoManager.ListGroups(userPoolID);
  }

  async CognitoListUsersInGroup(userPoolID, GroupName) {
    if (this.AWSCognitoManager == null) throw "AWSCognitoManager not set";
    return await this.AWSCognitoManager.ListUsersInGroup(userPoolID, GroupName);
  }

  async CognitoListUsersWithGroup(userPoolID) {
    if (this.AWSCognitoManager == null) throw "AWSCognitoManager not set";
    return await this.AWSCognitoManager.ListUsersWithGroup(userPoolID);
  }
  async CognitoListUsers(userPoolID) {
    if (this.AWSCognitoManager == null) throw "AWSCognitoManager not set";
    return await this.AWSCognitoManager.ListUsers(userPoolID);
  }
  async CognitoGetUser(userPoolID, username) {
    if (this.AWSCognitoManager == null) throw "AWSCognitoManager not set";
    return await this.AWSCognitoManager.GetUser(userPoolID, username);
  }
  async CognitoEnableUser(userPoolID, username) {
    if (this.AWSCognitoManager == null) throw "AWSCognitoManager not set";
    return await this.AWSCognitoManager.EnableUser(userPoolID, username);
  }
  async CognitoDisableUser(userPoolID, username) {
    if (this.AWSCognitoManager == null) throw "AWSCognitoManager not set";
    return await this.AWSCognitoManager.DisableUser(userPoolID, username);
  }
  async CognitoGetUserGroups() {
    if (this.AWSCognitoManager == null) throw "AWSCognitoManager not set";
    return await this.AWSCognitoManager.GetUserGroups();
  }
  async CognitoCreateUser(params, email, username, UserPoolID="", ClientID="") {
    if (this.AWSCognitoManager == null) throw "AWSCognitoManager not set";
    return await this.AWSCognitoManager.CreateUser(params, email, username, UserPoolID,ClientID);
  }
  async CognitoAddUserToGroup(UserPoolID, Groupname, Username) {
    if (this.AWSCognitoManager == null) throw "AWSCognitoManager not set";
    return await this.AWSCognitoManager.AddUserToGroup(
      UserPoolID,
      Groupname,
      Username
    );
  }
  async CognitoLogout() {
    if (this.AWSCognitoManager == null) throw "AWSCognitoManager not set";
    return await this.AWSCognitoManager.LogoutUser();
  }

  //DYNAMO DB METHODS
  async UseDynamoDB() {
    if (sessionStorage.getItem("Logged") === "true") {
      await this.AWSCognitoManager.RefreshCredentials();
      if (this.AWSDynamoDbManager == null) {
        const DynamoDbClient =
          await this.AWSCognitoManager.CreateDynamoDbClient();
        this.AWSDynamoDbManager = new AWSDynamoDBManager(DynamoDbClient);
      } else {
        await this.AWSCognitoManager.RefreshCredentials();
      }
    } else throw "User not logged";
  }
  async DynamoDBGetItem(params) {
    await this.UseDynamoDB();
    return await this.AWSDynamoDbManager.GetItem(params);
  }
  async DynamoDBPutItem(params) {
    await this.UseDynamoDB();
    return await this.AWSDynamoDbManager.PutItem(params);
  }
  async DynamoDBUpdateItem(params) {
    await this.UseDynamoDB();
    return await this.AWSDynamoDbManager.UpdateItem(params);
  }
  async DynamoDBDeleteItem(params) {
    await this.UseDynamoDB();
    return await this.AWSDynamoDbManager.DeleteItem(params);
  }
  async DynamoDBQuery(params) {
    await this.UseDynamoDB();
    return await this.AWSDynamoDbManager.QueryDB(params);
  }
  async DynamoDBScan(params) {
    await this.UseDynamoDB();
    return await this.AWSDynamoDbManager.ScanDB(params);
  }

  //LAMBDA Methods
  async UseLambda() {
    if (sessionStorage.getItem("Logged") === "true") {
      if (this.LambdaManager == null) {
        await this.AWSCognitoManager.RefreshCredentials();
        const client = await this.AWSCognitoManager.CreateLambdaClient();
        this.LambdaManager = new AWSLambdaManager(client);
      } else {
        await this.AWSCognitoManager.RefreshCredentials();
      }
    } else throw "User not logged";
  }

  async LambdaInvoke(FunctionName,InvocationType, Payload) {
    await this.UseLambda();
    return await this.LambdaManager.Invoke(FunctionName,InvocationType, Payload);
  }

  //S3 Methods
  async UseS3() {
    if (sessionStorage.getItem("Logged") === "true") {
      if (this.S3Manager == null) {
        await this.AWSCognitoManager.RefreshCredentials();
        const client = await this.AWSCognitoManager.CreateS3Client();
        this.S3Manager = new AWSS3Manager(client);
      } else {
        await this.AWSCognitoManager.RefreshCredentials();
      }
    } else throw "User not logged";
  }

  async GetS3Item(BucketName, Key) {
    await this.UseS3();
    return await this.S3Manager.GetS3Item(BucketName, Key);
  }
  async PutS3Item(BucketName, Key, Body) {
    await this.UseS3();
    return await this.S3Manager.UpdateS3Item(BucketName, Key, Body);
  }
}
